<template>
  <client-only>
    <!-- メンテナンス時に使用するレイアウト -->
    <AtomsJiji />
    <main class="l-main">
      <slot />
    </main>
  </client-only>
</template>

<style scoped lang="scss">
.l-main {
  flex: 1;
  margin: auto 0;
  min-height: calc(100vh);
  display: flex;
  align-items: center;
  justify-content: center;
}

.l-header {
  position: fixed;
  top: 0;
}
</style>
